'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('overrides/clappr/base/events');

var _events2 = _interopRequireDefault(_events);

var _clapprZepto = require('clappr-zepto');

var _clapprZepto2 = _interopRequireDefault(_clapprZepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLAYING = 'playing';
var PAUSED = 'paused';
var BOOTING = 'booting';

var Recording = function () {
    _createClass(Recording, [{
        key: 'isPlaying',
        get: function get() {
            return this.state == PLAYING;
        }
    }]);

    function Recording(player) {
        var links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Recording);

        this._player = player;
        var defaultLinks = {
            pause: null,
            resume: null,
            self: null,
            speed: null
        };
        this._links = _clapprZepto2.default.extend(defaultLinks, links);
        this._addEventListeners();

        // State of player
        this.state = BOOTING;
        this.speed = 1;
    }

    _createClass(Recording, [{
        key: '_addEventListeners',
        value: function _addEventListeners() {
            var _this = this;

            this._player.on(_events2.default.PLAYER_PLAY, function () {
                return _this._onPlay();
            });
            this._player.on(_events2.default.PLAYER_PAUSE, function () {
                return _this._onPause();
            });
            this._player.on(_events2.default.PLAYER_STOP, function () {
                return _this._onPause();
            });
            this._player.on(_events2.default.PLAYER_PLAYBACK_RATE, function (rate) {
                return _this._onPlaybacRateChange(rate);
            });
        }
    }, {
        key: '_removeEventsListeners',
        value: function _removeEventsListeners() {
            this._player.off(_events2.default.PLAYER_PLAY);
            this._player.off(_events2.default.PLAYER_PAUSE);
            this._player.off(_events2.default.PLAYER_STOP);
            this._player.off(_events2.default.PLAYER_PLAYBACK_RATE);
        }
    }, {
        key: '_onPlay',
        value: function _onPlay() {
            var _this2 = this;

            if (!this.isPlaying) {
                _clapprZepto2.default.ajax({
                    type: 'POST',
                    url: this._links.resume,
                    error: function error(xhr, type) {
                        if (xhr.status == 404) {
                            _this2.destroy();
                        }
                    }
                });
                this.state = PLAYING;
            }
        }
    }, {
        key: '_onPause',
        value: function _onPause() {
            var _this3 = this;

            if (this.isPlaying) {
                _clapprZepto2.default.ajax({
                    type: 'POST',
                    url: this._links.pause,
                    error: function error(xhr, type) {
                        if (xhr.status == 404) {
                            _this3.destroy();
                        }
                    }
                });
                this.state = PAUSED;
            }
        }
    }, {
        key: '_onPlaybacRateChange',
        value: function _onPlaybacRateChange(rate) {
            var _this4 = this;

            if (rate !== this.speed) {
                _clapprZepto2.default.ajax({
                    type: 'POST',
                    url: this._links.speed,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify({ speed: rate }),
                    error: function error(xhr, type) {
                        if (xhr.status == 404) {
                            _this4.destroy();
                        }
                    }
                });
                this.speed = rate;
            }
        }

        /**
         * Get stream current time
         * @returns {void}
         */

    }, {
        key: 'getCurrentTime',
        value: function getCurrentTime(cb) {
            _clapprZepto2.default.ajax({
                type: 'GET',
                url: this._links.self,
                success: function success(data) {
                    cb(null, data.current_position);
                },
                error: function error(xhr, type) {
                    cb(type, null);
                }
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            _clapprZepto2.default.ajax({ type: 'DELETE', url: this._links.self });
            this._removeEventsListeners();
        }
    }]);

    return Recording;
}();

exports.default = Recording;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/recording.js
// module id = 304
// module chunks = 0